<template>
  <div>
    <TableView
      :onSearch="getConsultaExame"
      :tableData="tableData"
      :tableHead="tableHead"
      :pagination="pagination"
      :response="response"
      :loadingTable="loadingTable"
      disableInputSearch
      disableCheckAll
      disabledConfigCell
    />
  </div>
</template>

<script>

import Rest from 'common/rest'
import TableView from 'common/table'

export default {
    name: 'empresa.consulta.exame',
    components:{TableView},
    mixins:[Rest],
    data () {
      return{
        tableHead: [
          {
            key: 'exame',
            sortable: true,
            show_rea:true,
            show_dem:true,
            //show_parceiro:true,
            label: 'Exame',
          },
           {
            key: 'data',
            sortable: true,
            label: 'Data',
          },
          {
            key: 'valor',
            sortable: true,
            show_html:true,
            label: 'Valor (R$)',
          },
          {
            key: 'valor_servico',
            sortable: true,
            show_html:true,
            label: 'Taxa de Serviço (R$)',
          },
          {
            key: 'valor_total',
            sortable: true,
            show_html:true,
            label: 'Valor Total (R$)',
          },
        ],
        tableData: [],
        loadingTable: false,
        pagination:{},
        response:{},
      }
    },
    beforeDestroy(){
			this.tableData = [];
		},
    created(){
    },

    mounted(){
      this.getConsultaExame();
    },

    computed: {
    },

    methods:{

      onEdit(data){

      },

      getConsultaExame(search,page,pagination){

        this.loadingTable = true;
        this.response = {};

        this.get('consulta/externa/exame/'+this.$route.params.consulta,{search:search,page:page,pagination:pagination}).then((result) =>{
          result = result[0];

          this.loadingTable = false;
          this.response = result;

          var data = [], tableData = [], pagination = {};

          if(result.status == 200){
            
            data = result.data.data;
 
            for (var i = 0; i < data.length; i++) {

              let exa_pcmso = '';

              if(!data[i].pcmso_exame){
                exa_pcmso = '<br><span style="color:red">Exame não encontrado no PCMSO</span>'
              }
              var item = {
                id: data[i].id,
                exame: (data[i].exame ? data[i].exame.nome+exa_pcmso : null),
                data: this.toDate(data[i].data,true),
                valor: (data[i].va == '1' ? '<img src="'+this.env.url_cs+'app/1.img/img_sof/va.png" title="Incluso no Vida Ativa"/>' : data[i].valor),
                valor_servico: (data[i].va == '1' ? '<img src="'+this.env.url_cs+'app/1.img/img_sof/va.png" title="Incluso no Vida Ativa"/>' : data[i].valor_servico),
                valor_total: (data[i].va == '1' ? '<img src="'+this.env.url_cs+'app/1.img/img_sof/va.png" title="Incluso no Vida Ativa"/>' : data[i].valor_total),
                _data: data[i],
                buttons : []
              };

              tableData.push(item);
            }

            pagination = result.data;
          }

          this.tableData = tableData;
          this.pagination = pagination;
        });
      }
    }
}
</script>
</style>



// WEBPACK FOOTER //
// index.vue?5db5702e